import { useSelector } from 'react-redux';

import {
  selectGetAccountError,
  selectGetProfileError,
} from 'containers/App/selectors';

export const useGlobalFetchErrors = () => {
  // These selectors are needed to replicate old behaviour.
  // Will be removed when account and profile are moved to react-query state.
  const getAccountError = useSelector(selectGetAccountError);
  // yes, these two selectors actually *are* different, so this is a function I have to call here.
  const getProfileError = useSelector(selectGetProfileError());
  return { getAccountError, getProfileError };
};
